const config = [{
  desc: '获取下游结算配置',
  options: {
    url: '/config/queryConfig',
    method: 'post',
    formdata: true
  }
}, {
  desc: '编辑下游结算配置',
  options: {
    url: '/config/saveConfig',
    method: 'post',
    formdata: true
  }
}, {
  desc: '字符串加密（账号信息加密）',
  options: {
    url: '/config/decodeText',
    method: 'post'
  }
}, {
  desc: '上传图片',
  options: {
    url: '/file/uploadFile',
    method: 'post',
    formdata: true
  },
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}]
export default config



// WEBPACK FOOTER //
// ./src/api/config.js